/**
 * Convert Arabic-Indic digits (٠–٩) and Persian / Extended-Arabic
 * digits (۰–۹) to their Western ASCII equivalents (0–9).
 *
 * Arabic / Persian keyboard users routinely type phone numbers in
 * native script. Our validators and backend phone normaliser expect
 * plain 0–9, so without this step every Arabic-keyboard customer
 * looked like they typed garbage. Applied at the input onChange
 * layer so the field also visually normalises as the user types,
 * giving them confidence we read their number correctly.
 *
 * Non-string input is returned as-is.
 */
export function normalizeDigits(input) {
  if (input == null) return input;
  if (typeof input !== 'string') return input;
  return input
    .replace(/[٠-٩]/g, (d) => String(d.charCodeAt(0) - 0x0660))
    .replace(/[۰-۹]/g, (d) => String(d.charCodeAt(0) - 0x06F0));
}
